import React, { Component } from "react";
import config from "../../../common/config";
import Trans from "../../../componentsReusable/trans";

class ErrorPage extends Component {
  render() {
    return (
      <div className="m11c-cmo__wrap">
        <div className="m11c-cmo__lhs">
          <div className="m11c-hp__wrap m11c-hp__postLog m11c-hp__404">
            <div className="m11c-hp__mHead">
              <div className="m11c-hp__mHead-thumb">
                <img
                  src={config.IMG_BASE + "IPL-logo-white.png"}
                  alt="WWC Season Long 2025 Powered by My11Circle"
                />
              </div>
              <div className="m11c-hp__head">
                <div className="m11c-hp__thumb-svg">
                  <img
                    src={config.IMG_BASE + "404.svg"}
                    alt="error page"
                    title="404"
                  />
                </div>
                <div className="m11c-hp__title">
                  <span>
                    <Trans
                      sKey={"errorPageTitle"}
                      sValue={"Something went wrong while loading this page!"}
                    />
                  </span>
                </div>
                <div className="m11c-hp__title-subs">
                  <span>
                    <Trans
                      sKey={"errorPageDesc"}
                      sValue={
                        "Simply refresh the page to return to the action."
                      }
                    />
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ErrorPage;
